import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EDataPaymentActions } from '../../constants/actionTypes/dataPayment';
import { EDealTypeEx } from '../../constants/dealTypeEx';
import { EDemandRequestStatus } from '../../constants/demandRequestStatus';

export interface ISetDemandRequestStatus {
  /** Состояние заявки **/
  status: EDemandRequestStatus;
  /** Требуется ли дозапросить телефон **/
  phoneRequired: boolean;
  /** Требуется ли дозапросить цель заявки **/
  dealTypeRequired: boolean;
}

export const setDemandRequestStatus = actionGenerator<
  EDataPaymentActions.SET_DEMAND_REQUEST_STATUS,
  ISetDemandRequestStatus
>(EDataPaymentActions.SET_DEMAND_REQUEST_STATUS);
export const setDemandRequestPhone = actionGenerator<EDataPaymentActions.SET_PHONE, string>(
  EDataPaymentActions.SET_PHONE,
);
export const setDemandRequestDealType = actionGenerator<EDataPaymentActions.SET_DEAL_TYPE, EDealTypeEx>(
  EDataPaymentActions.SET_DEAL_TYPE,
);
export const setDemandRequestSent = actionGenerator<EDataPaymentActions.SEND_DEMAND_REQUEST>(
  EDataPaymentActions.SEND_DEMAND_REQUEST,
);
export const setDemandRequestSuccess = actionGenerator<EDataPaymentActions.SEND_DEMAND_REQUEST_SUCCESS>(
  EDataPaymentActions.SEND_DEMAND_REQUEST_SUCCESS,
);
export const setDemandRequestError = actionGenerator<EDataPaymentActions.SEND_DEMAND_REQUEST_ERROR>(
  EDataPaymentActions.SEND_DEMAND_REQUEST_ERROR,
);

export type TDataPaymentActions =
  | ReturnType<typeof setDemandRequestStatus>
  | ReturnType<typeof setDemandRequestPhone>
  | ReturnType<typeof setDemandRequestDealType>
  | ReturnType<typeof setDemandRequestSent>
  | ReturnType<typeof setDemandRequestSuccess>
  | ReturnType<typeof setDemandRequestError>;
